<template>
  <HubContainer id="menuConfigurationHub">

    <HubSection large icon="icon/hub/settings.svg" v-if="atLeastSuperAdmin"
                :title="$t('inventory.current_menu_settings')"
                :description="$t('inventory.current_menu_settings_description')"
                :buttonAction="goToInventorySettings">
    </HubSection>

    <template v-if="!company">
      <HubSection large icon="icon/hub/company.svg" v-if="!multiInventoryActivated"
                  :title="$t('inventory.catalogs')"
                  :description="$t('catalogs_dashboard.description')"
                  :buttonAction="goToCatalogsHub">
      </HubSection>
    </template>

    <template v-if="company">
      <HubSection large icon="icon/hub/company.svg" v-if="$store.getters.isBranchContextInventory && canManageCatalog"
                  :title="$t('inventory.catalogs')"
                  :description="$t('catalogs_dashboard.description')"
                  :buttonAction="goToCompanyCatalogs">
      </HubSection>
      <HubSection large icon="icon/hub/company.svg" v-if="!$store.getters.isBranchContextInventory && !isPosOnly"
                  :title="$t('inventory.catalogs')"
                  :description="$t('catalogs_dashboard.description')"
                  :buttonAction="goToCatalogs">
      </HubSection>
    </template>

    <HubSection large icon="icon/hub/cart.svg" v-if="selectedInventory && selectedInventory.orderRequirementsActivated"
                :title="$t('inventory.order_requirements')"
                :description="$t('inventory.order_requirements_description')"
                :buttonAction="goToOrderRequirements">
    </HubSection>

    <HubSection large icon="icon/hub/schedules.svg"
                :title="$t('inventory.schedules')"
                :description="$t('items.schedules_description')"
                :buttonAction="goToSchedules">
    </HubSection>

    <HubSection large icon="icon/hub/labels.svg"
                :title="$t('inventory.tags')"
                :description="$t('inventory.tags_description')"
                :buttonAction="goToLabels">
    </HubSection>

  </HubContainer>
</template>

<script>
import HubSection from "@/components/HubSection";
import HubContainer from "@/components/HubContainer";

export default {
  name: "MenuConfigurationHub",

  components: { HubSection, HubContainer },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "inventory.settings.title";
    this.$store.state.pageIcon = "/icon/menu.svg";

    if (this.$route.query.branch) {
      let branchModule = await this.$store.getters.getContextBranchActivatedModule;
      Object.assign(this.moduleActivated, branchModule);
    }

    if (this.$route.query.company) {
      let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
      Object.assign(this.moduleActivated, companyModule);
    }
  },

  data() {
    return {
      moduleActivated: {
        onlineOrdering: false,
        kiosk: false,
        mobileApp: false,
        menuBoard: false,
        loyalty: false,
        thirdPartyLoyalty: false,
        aimsVouchers: false,
        onSiteOrdering: false,
        payAtTheTable: false,
        catering: false,
        dispatch: false,
        POS: false,
      }
    }
  },

  computed: {
    selectedInventory() {
      return this.$store.state.contextInventory;
    },
    multiInventoryActivated() {
      return this.branch ? this.branch.inventories.length > 0 : false;
    },
    company() {
      return this.$store.state.contextCompany;
    },
    branch() {
      return this.$store.state.contextBranch;
    },
    canManageCatalog() {
      let fields = this.$store.getters.getOverloadableFields;
      if (!this.$route.query.company || !this.$store.getters.isBranchContextInventory || fields.length === 0) {
        return false;
      }
      return fields.indexOf("catalogExclusions") > -1;
    },
    atLeastSuperAdmin() {
      return this.$store.getters.loggedUserHasSuperAdmin;
    },
    atLeastBranchAdmin() {
      return this.$store.getters.loggedUserHasBranchAdmin;
    },
    hasAtLeastOneOnlineOrderingPlatformActive() {
      let validKeys = ["POS", "thirdPartyLoyalty", "loyalty"];
      for (const [key, value] of Object.entries(this.moduleActivated)) {
        if (value && !validKeys.includes(key)) {
          return true;
        }
      }
      return false;
    },
    isPosOnly() {
      return this.moduleActivated.POS && !this.hasAtLeastOneOnlineOrderingPlatformActive;
    }
  },

  methods: {
    goToInventorySettings() {
      this.$router.push(this.$router.buildContext("/inventory"));
    },
    goToCatalogsHub() {
      this.$router.push(this.$router.buildContext("/catalog/hub"));
    },
    goToCompanyCatalogs() {
      this.$router.push(this.$router.buildContext("/catalog/company-catalogs"));
    },
    goToCatalogs() {
      this.$router.push(this.$router.buildContext("/catalogs"));
    },
    goToOrderRequirements() {
      this.$router.push(this.$router.buildContext("/order-requirements"));
    },
    goToSchedules() {
      this.$router.push(this.$router.buildContext("/inventory_hours"));
    },
    goToLabels() {
      this.$router.push(this.$router.buildContext("/tags"));
    },
  }
}
</script>